import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router';

const Step = ({ step, label, active, done, link, url }) => {
  const history = useHistory();

  let className = 'step';
  if (done) className += ' done';
  if (active) className += ' active';

  return (
    <div className={className}>
      <div
        className="step-num"
        style={link ? { cursor: 'pointer' } : {}}
        onClick={() => { if (link) history.push(url); }}
      >
        {step}
      </div>
      <div className="step-label">{label}</div>
    </div>
  );
};

Step.propTypes = {
  step: PropTypes.number.isRequired,
  label: PropTypes.string.isRequired,
  active: PropTypes.bool,
  done: PropTypes.bool,
  link: PropTypes.bool,
  url: PropTypes.string,
};

export default Step;
